<template>
    <component
        :is="tag"
        type="button"
        :href="href"
        :class="classObject"
    >
        <slot></slot>
    </component>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults } from 'vue';
import { Functional } from '@/types';

interface Props {
    type?: Functional;
    href?: string;
}

const props = withDefaults(defineProps<Props>(), {
    type: Functional.Info,
    href: undefined,
});

const tag = computed(() => {
    if (props.href) {
        return 'a';
    }

    return 'button';
});

const classObject = computed(() => ({
    'rounded-md px-2 py-1.5 font-medium focus:outline-hidden focus:ring-2 focus:ring-offset-2': true,
    'text-brand hover:text-brand--light focus:ring-blue-600 focus:ring-offset-blue-400 ':
        props.type === Functional.Info,
}));
</script>
